module.exports = __webpack_public_path__ + "bac7c498d0fd3f7d9851ef10b94c4820.MP3";